import {WORKFLOW_OBJ_TYPE_DATASTORE_LIST} from '../index'

export const datastoreOperationTypes = Object.freeze({
    add: {
        key: 'add',
        label: 'Add'
    }
    // not supported yet:
    // edit: {
    //     key: 'edit',
    //     label: 'Edit'
    // },
    // delete: {
    //     key: 'delete',
    //     label: 'Delete'
    // }
})

export const datastoreOperationTypesList = Object.freeze(Object.values(datastoreOperationTypes))

export const datastoreTypes = Object.freeze({
    [WORKFLOW_OBJ_TYPE_DATASTORE_LIST]: {
        key: WORKFLOW_OBJ_TYPE_DATASTORE_LIST,
        label: 'List'
    }
    // not supported yet:
    // object: {
    //     key: 'object',
    //     label: 'object'
    // }
})

export const datastoreTypesList = Object.freeze(Object.values(datastoreTypes))
